import { render, staticRenderFns } from "./user-docs-form.vue?vue&type=template&id=478aa0e8&scoped=true&lang=pug&"
import script from "./user-docs-form.vue?vue&type=script&lang=ts&"
export * from "./user-docs-form.vue?vue&type=script&lang=ts&"
import style0 from "./user-docs-form.vue?vue&type=style&index=0&id=478aa0e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478aa0e8",
  null
  
)

export default component.exports